import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedRequestTypesRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-request-types',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/request-types',
	exact: true,
};
